module.exports = __webpack_public_path__ + "assets/img/9041e9a243d710b57d94740c9eaddc13.svg";